// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__lnhYt","large":"styles_large__HDf7g"};